import {Button, Checkbox, Form, Modal, Spin} from 'antd';
import * as Hangul from 'hangul-js';
import React from 'react';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import { setDeposit } from '../actions/depositAction';
import { login, logout } from '../actions/loginAction';
import { setKeyboardSetting, setMultiPosSetting } from '../actions/posAction';
import { httpGet, httpPost, httpUrl, imageUrl } from '../api/httpClient';
import Const from '../const';
import ClickSwitch from './input/ClickSwitch';
import KeyInputModal from './modal/KeyInputModal';
import PasswordDialog from './modal/PasswordDialog';
import image from '../res/image';
import string from '../res/string';
import {modalStyle} from "../lib/util/codeUtil";

const FormItem = Form.Item;

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saveLoginId: false,

      keyInputModalOpen: false,
      keyInputId: '',

      passwordDialog: false,
      passwordValid: 0,

      frCalculateHour: 0,
      skinPopupList: [],
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.getStorageLoginInfo();
    this.getStorageKeyboardSetting();
    this.getStorageMultiPosSetting();
    this.getStorageBranchTel();
    this.getSkinPopupList();
  }

  getStorageLoginInfo = () => {
    let value = reactLocalStorage.getObject(Const.appName + ':auth');

    if (value !== null) {
      try {
        value = JSON.parse(value);
      } catch {}
      if (value.type === 'saveLoginId') {
        this.formRef.current.setFieldsValue({ id: value.id });
        this.setState({ saveLoginId: true });
      }
    }
  };
  onChangeKeyBoardSetting = (value) => {
    this.props.setKeyboardSetting(value);
  };

  getStorageKeyboardSetting = () => {
    const keyboardSetting = reactLocalStorage.getObject(
      Const.appName + '#keyboardSetting'
    );

    if (
      keyboardSetting !== null &&
      keyboardSetting !== undefined &&
      typeof keyboardSetting !== 'object'
    ) {
      this.props.setKeyboardSetting(keyboardSetting);
    }
  };

  getStorageMultiPosSetting = () => {
    const multiPosSetting = reactLocalStorage.getObject(
      Const.appName + '#multiPosSetting'
    );

    if (
      multiPosSetting !== null &&
      multiPosSetting !== undefined &&
      typeof multiPosSetting !== 'object'
    ) {
      this.props.setMultiPosSetting(multiPosSetting);
    }
  };

  getStorageBranchTel = () => {
    const branchTel = reactLocalStorage.getObject(Const.appName + '#branchTel');

    return branchTel;
  };

  getStorageCalculateHour = () => {
    const calculateHour = reactLocalStorage.getObject(
      Const.appName + '#calculateHour'
    );

    return calculateHour;
  };

  openKeyInputModal = (keyInputId) => {
    this.setState({ keyInputId, keyInputModalOpen: true });
  };
  closeKeyInputModal = () => {
    this.setState({ keyInputId: '', keyInputModalOpen: false });
  };
  login = (e) => {
    if (window.location.hostname === 'yj.rider.nyamnyambox.com' ||
        window.location.hostname === 'gy.rider.nyamnyambox.com' ||
        window.location.hostname === 'rider.nyamnyambox.com') {
      Modal.info({
        content:"현재 접속하고 있는 주소는 만료될 예정입니다. 지점에 문의하여 반드시 URL을 재설정 해주세요.",
        ...modalStyle,
      })
    }

    const form = this.formRef.current;
    httpPost(httpUrl.login, [], {
      ...form.getFieldsValue(),
      deviceId: 'WEB',
      uniqueId: 'FRANCHISE',
    })
      .then((result) => {
       

        result = result.data;
        if (result.result) {

          if (result.user.userStatus !== 1) {
            this.props.alert.show('중지/탈퇴인 사용자입니다.');
            return;
          }
          if (result.user.userType !== 2) {
            this.props.alert.show('사용자가 가맹점이 아닙니다.');
            return;
          }

          this.props.login(result.user);

          let localData = {};
          if (this.state.saveLoginId) {
            localData = {
              type: 'saveLoginId',
              id: form.getFieldValue('id'),
            };
          }
          reactLocalStorage.setObject(
            Const.appName + ':auth',
            JSON.stringify(localData)
          );

          if (result.user.passwordValid == 1) {
            this.setState({
              passwordDialog: true,
              passwordValid: result.user.passwordValid,
            });
          } else {
            this.getCalculateHour().then(() => {});

            this.getDepositInfo().then(() => {
              this.props.history.push('/Delivery');
            });
          }
        } else {
          if (result.reason == 'INVALID_LOGIN_ID')
            this.props.alert.show('아이디 또는 비밀번호가 잘못되었습니다.');
          else if (result.reason == 'INVALID_LOGIN_PASSWORD')
            this.props.alert.show('아이디 또는 비밀번호가 잘못되었습니다.');
          else if (result.reason == 'INVALID_USER_STATUS')
            this.props.alert.show('유효하지 않은 사용자입니다.');
          else if (result.reason == 'EXPIRED')
            this.props.alert.show('유효하지 않은 사용자입니다.');
          else if (result.reason == 'DORMANT')
            this.props.alert.show('휴면계정입니다.');
          else if (result.reason == 'LOCKED')
            this.props.alert.show('로그인 실패로 잠긴 계정입니다.');
          else this.props.alert.show('로그인에 실패하였습니다.');
        }
      })
      .catch((e) => {
        this.props.alert.show('로그인에 실패하였습니다');
      });
  };

  getDepositInfo = () => {
    return new Promise((resolve, reject) => {
      httpGet(httpUrl.riderNCash, [], {})
        .then((result) => {
          this.props.setDeposit(result.data.ncash);
          resolve();
        })
        .catch((e) => {
          reject();
        });
    });
  };

  getCalculateHour = () => {
    return new Promise((resolve, reject) => {
      httpGet(httpUrl.getCalculateHour, [], {})
        .then((result) => {
          reactLocalStorage.setObject(
            Const.appName + '#calculateHour',
            result.data
          );
          this.setState({ calculateHour: result.data });
          this.props.updateCalculateHour(result.data);
          resolve();
        })
        .catch((e) => {
          reject();
        });
    });
  };

  getSkinPopupList = () => {
    const categoryList = [1];
    const deleted = 0;
    const userInfo = reactLocalStorage.getObject(Const.appName + "#userinfo");
    const branchIdx = userInfo?.branchIdx;
    httpGet(httpUrl.getSkinPopupList, [categoryList, deleted, branchIdx], {})
    .then(res => {
      if(res.result === "SUCCESS" && res.data.list.length > 0) {
        this.setState({
          skinPopupList: res.data.list
        });
      }
    })
    .catch(e => {
      console.error(e);
    });

  }

  onRemoteSupport = () => {
    window.open(Const.remoteSupportUrl);
  };
  onExit = () => {
    const action = global.executeBridgeAction({
      action: 'ExitApp',
      message: '',
    });
    action
      .then((res) => {
        if (res.result !== 'Success') {
        }
      })
      .catch((e) => {
      });
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
    };

    const {skinPopupList} = this.state;
    const skinType = Const.skinType.toUpperCase();

    return (
      <div className="main">
        <div
          id="loadingSpinner"
          style={{
            display: 'none',
            position: 'fixed',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.3)',
            top: 0,
            left: 0,
            textAlign: 'center',
            zIndex: 99999,
            // pointerEvents: "none"
          }}>
          <Spin style={{ position: 'absolute', top: '50%', zIndex: 99999 }} />
        </div>
        <div className="wrapper">
          <div className="container">
            <div
              className={skinPopupList.length > 0 ? "login-bg2" : "login-bg"}
              style={
              skinType === "GOGOIT" ?
                  {
                    backgroundImage: `url(${require("../img/gogoit_bg.png")})`,
                  }
                  :
                skinPopupList.length > 0
                  ? {
                      backgroundImage: `url(${imageUrl(skinPopupList[0].uploadFileIdx)})`,
                    }
                  : {
                    backgroundImage: `url(${require("../img/franchise_bg.png")})`,
                  }
              }
              >
              <div className="top-main">
                <div className={skinPopupList.length > 0 ? "top-main-center2" : "top-main-center"}>
                  <div className="top-title">{string.name}</div>
                  <div className="top-sub">가맹점 시스템</div>
                  <div className={skinPopupList.length > 0 ? "top-input2" : "top-input"}>
                    <Form
                      ref={this.formRef}
                      {...formItemLayout}
                      onFinish={this.login}>
                      <div className={skinType === "GOGOIT" ? "gogoit-top-input-box" : "top-input-box"}>
                        <div className={skinType === "GOGOIT" ? "gogoit-top-input-content1" : "top-input-content1"}>
                          <img
                            className="top-input-img"
                            style={{ display: 'inline' }}
                            src={image.InputIdIcon}
                            alt=""
                          />
                          <div className="top-input-content1-input">
                            <FormItem
                              focus="unfocus"
                              name="id"
                              rules={[
                                {
                                  required: true,
                                  message: '아이디를 입력해주세요',
                                },
                              ]}>
                              <input
                                id="input-id"
                                onFocus={() => {
                                  this.openKeyInputModal('id');
                                }}
                                autoComplete="off"
                                style={{backgroundColor: skinType === "GOGOIT" ? '#1ECAD3' : ''}}
                              />
                            </FormItem>
                          </div>
                        </div>
                        <div className={skinType === "GOGOIT" ? "gogoit-top-input-content2" : "top-input-content2"}>
                          <img
                            className="top-input-img"
                            style={{ display: 'inline' }}
                            src={image.InputPwIcon}
                            alt=""
                          />
                          <div className="top-input-content2-input">
                            <FormItem
                              name="password"
                              rules={[
                                {
                                  required: true,
                                  message: '비밀번호를 입력해주세요',
                                },
                              ]}>
                              <input
                                type="password"
                                id="input-pw"
                                onFocus={() => {
                                  this.openKeyInputModal('password');
                                }}
                                autoComplete="off"
                                style={{backgroundColor: skinType === "GOGOIT" ? '#1ECAD3' : ''}}
                              />
                            </FormItem>
                          </div>
                        </div>

                        <div className="top-input-checkbox mobile">
                          <Checkbox
                            style={{ paddingRight: 5.7 }}
                            onChange={(e) => {
                              this.setState({ saveLoginId: e.target.checked });
                            }}
                            checked={this.state.saveLoginId}
                          />
                          <div className="top-input-checkbox-text">
                            아이디 저장
                          </div>
                        </div>
                      </div>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="login-btn">
                        로그인
                      </Button>
                    </Form>
                    <div className="top-input-checkbox mobileoff">
                      <Checkbox
                        style={{ paddingRight: 5.7 }}
                        onChange={(e) => {
                          this.setState({ saveLoginId: e.target.checked });
                        }}
                        checked={this.state.saveLoginId}
                      />
                      <div className="top-input-checkbox-text">아이디 저장</div>
                    </div>
                    {skinType === "NNBOX" &&
                        <div className="top-btn-box">
                          <div
                              className="top-input-btn mobileoff"
                              onClick={() => {
                                this.onRemoteSupport();
                              }}>
                            원격지원
                          </div>
                          <div className="top-input-btn2 mobileoff">
                            <a
                                href="/remote_guide.pdf"
                                onClick={() => window.open('/remote_guide.pdf')}
                                download>
                              <span style={{color: 'red'}}>*</span>지원도움말
                            </a>
                          </div>
                          <div className="top-input-btn3 mobileoff">
                            <a
                                href="/franchise_guide.pdf"
                                onClick={() => window.open('/franchise_guide.pdf')}
                                download>
                              <span style={{color: 'red'}}>*</span>가이드
                            </a>
                          </div>
                          {/* <input type="submit" onClick="window.open('../img/pdf/remote_guide.pdf';return true;"
                                            ></input> */}
                        </div>
                    }
                    <div style={{ marginTop: 20 }}>
                      <div className="top-input-checkbox-text">키보드 설정</div>
                      <ClickSwitch
                        flag={this.props.posReducer.keyboardSetting}
                        className="pos-element-block10-content-img"
                        onChange={(value) =>
                          this.onChangeKeyBoardSetting(value, false)
                        }
                      />
                    </div>
                  </div>
                  <div className="login-contact mobileoff">
                    긴급연락처:
                    {Object.keys(this.getStorageBranchTel()).length !== 0
                      ? this.getStorageBranchTel()
                      : ''}
                  </div>
                  <div className="login-contact2 mobileoff">
                    버전: {Const.clientMinorVersion}
                  </div>
                  <div className="login-contact mobile">
                    긴급연락처:
                    {Object.keys(this.getStorageBranchTel()).length !== 0
                      ? this.getStorageBranchTel()
                      : ''}
                  </div>
                  <div className="login-contact2 mobile">
                    버전: {Const.clientMinorVersion}
                  </div>
                </div>
                <div className="loginKeypad desk">
                  <KeyInputModal
                    isOpen={this.state.keyInputModalOpen}
                    close={this.closeKeyInputModal}
                    current={2}
                    keyin={(data) => {
                      const str = this.formRef.current.getFieldValue(
                        this.state.keyInputId
                      );
                      this.formRef.current.setFieldsValue({
                        [this.state.keyInputId]: str
                          ? Hangul.assemble([...Hangul.disassemble(str), data])
                          : data + '',
                      });
                    }}
                    backspace={() => {
                      const str = this.formRef.current.getFieldValue(
                        this.state.keyInputId
                      );
                      this.formRef.current.setFieldsValue({
                        [this.state.keyInputId]: str
                          ? str.substr(0, str.length - 1)
                          : '',
                      });
                    }}
                    ok={() => {
                      this.setState({ keyInputModalOpen: false });
                    }}
                  />
                </div>
                <div className="loginKeypad pos">
                  <KeyInputModal
                    isOpen={this.state.keyInputModalOpen}
                    close={this.closeKeyInputModal}
                    current={2}
                    keyin={(data) => {
                      const str = this.formRef.current.getFieldValue(
                        this.state.keyInputId
                      );
                      this.formRef.current.setFieldsValue({
                        [this.state.keyInputId]: str
                          ? Hangul.assemble([...Hangul.disassemble(str), data])
                          : data + '',
                      });
                    }}
                    backspace={() => {
                      const str = this.formRef.current.getFieldValue(
                        this.state.keyInputId
                      );
                      this.formRef.current.setFieldsValue({
                        [this.state.keyInputId]: str
                          ? str.substr(0, str.length - 1)
                          : '',
                      });
                    }}
                    ok={() => {
                      this.setState({ keyInputModalOpen: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.passwordDialog && (
          <PasswordDialog
            passwordValid={this.state.passwordValid}
            close={() => this.setState({ passwordDialog: false })}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer, posReducer } = state;
  return { loginReducer, posReducer };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      login,
      logout,
      setDeposit,
      setKeyboardSetting,
      setMultiPosSetting,
    },
    dispatch
  );

export default withAlert()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Login))
);
